import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ShipmentPlannerProfileListFacade } from './shipment-planner-profile-list.facade';
import { loadStoreState, setInitialStoreState } from '../../../../../common/utils';

@Injectable({
  providedIn: 'root',
})
export class ShipmentPlannerProfileListGuard {
  constructor(private shipmentPlannerProfileListFacade: ShipmentPlannerProfileListFacade) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.shipmentPlannerProfileListFacade);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.shipmentPlannerProfileListFacade);
  }
}
